import moment from 'moment';
import { getActionItemCreatedOnDate, getActionItemCreatedOnMonth, getActionItemCreatedOnQuarter, getActionItemCreatedOnWeek, getActionItemCreatedOnYear, getActionItemUpdatedOnDate, getActionItemUpdatedOnMonth, getActionItemUpdatedOnQuarter, getActionItemUpdatedOnWeek, getActionItemUpdatedOnYear } from '../Sort/checkDate/getDate';
const GROUP_BY_KEYS = [
  'total',
  'Created on - Year',
  'Created on - Quarter',
  'Created on - Month',
  'Created on - Day',
  'Created on - YearWeek',
  'Created on - Week Day',
  'Updated on - Year',
  'Updated on - Quarter',
  'Updated on - Month',
  'Updated on - Day',
  'Updated on - YearWeek',
  'Updated on - Week Day',
  'frequencyAndDirectionBinned',
  'whosePandL',
  'actualImpactUpdateCheck',
  'workstreamSponsorWorkstream',
  'workstreamLeadSubworkstream',
  'crossFunctionalSupportWorkstream',
  'initiativeNumber - initiativeName',
  'stage',
  'Stage (simplified)',
  'workstreamLeadPendingApproval',
  'workstreamSponsorPendingApproval',
  'financeLeadPendingApproval',
  'Strategy analyst pending approval?',
  'planningSummary',
  'Planning summary (simplified)',
  'netRecurringBenefitsRange',
  'Future implementation costs range',
  'l2LatestEstimatedDate',
  'l2ForecastDate',
  'L3 date compliance check (forecast vs planned date)',
  'L4 date compliance check (forecast vs planned date)',
  'Number of Attachment',
  'actualKpiUpdateCheck',
  '(FY24-25) Actual impact update check',
  '(FY23-24) Actual impact update check',
  'Has qualitative KPI?',
  'cancellationDate',
  'l3LatestEstimatedDate',
  'l3ForecastDate',
  'l3PlannedDate',
  'l4LatestEstimatedDate',
  'l4ForecastDate',
  'l4PlannedDate',
  'l5LatestEstimatedDate',
  'l5ForecastDate',
  'l0ActualDate',
  'l1ActualDate',
  'l2ActualDate',
  'l3ActualDate',
  'l4ActualDate',
  'l5ActualDate',
  'latestActualDateAllLGates',
  'subForL1ApprovDate',
  'subForL2ApprovDate',
  'subForL3ApprovDate',
  'subForL4ApprovDate',
  'subForL5ApprovDate',
  'pipelineWeeklyVarianceL0Plus',
  'pipelineWeeklyVarianceL1Plus',
  'pipelineWeeklyVarianceL2Plus',
  'pipelineWeeklyVarianceL3Plus',
  'pipelineWeeklyVarianceL4Plus',
  'TO Finance Lead',
  'workstreamLeadInfo',
  'workstreamSponsorInfo',
  'initiativeOwnerInfo',
  'initiativeOwnerBackupInfo',
  'AllowOnlyTo',
  'milestoneNumber',
  'name',
  '# - Name',
  'Owner',
  'status',
  'type',
  'Work starting date',
  'Milestone completion date',
  'Change in Milestone completion date (binned, current vs last week)',
  'Planning summary (simplified)',
  'planningSummary',
  '(LW) Planning summary',
  'planningCheck',
  'Created on',
  'Created by',
  'Updated on',
  'Updated by',
]
const groupWorkstreamActionsBy = (data, groupBy, users, determinePlanningSummary) => {
  if (groupBy === 'None' || groupBy === undefined || GROUP_BY_KEYS.includes(groupBy)) {
    return {};
  }
  const grouped = {};

  data.forEach((actionItem) => {
    let groupValue;

    if (groupBy === 'actionItemNumber') {
      groupValue = [actionItem.actionItemNumber];
    } else if (groupBy === 'workstreamActionName') {
      groupValue = [actionItem.workstreamActionName];
    } else if (groupBy === 'Accountable Workstream') {
      const ownerRole = actionItem.owner?.role?.name;
      let workstreamName;

      if (ownerRole === 'Workstream Sponsor') {
        workstreamName = actionItem.owner?.workstream?.workstreamName;
      } else {
        workstreamName = actionItem.owner?.subworkstream?.workstream?.workstreamName;
      }
      groupValue = [workstreamName];
    }
    else if (groupBy === 'Accountable subworkstream') {
      groupValue = [actionItem.owner?.subworkstream?.subworkstreamName];
    }
    else if (groupBy === 'owner') {
      groupValue = [actionItem?.owner ? `${actionItem?.owner.firstName || ''} ${actionItem?.owner.lastName || ''}` : 'Not Assigned'];
    } else if (groupBy === 'Action Status') {
      groupValue = [actionItem.status];
    } 
    else if(groupBy==='source'){
      groupValue=[actionItem?.source];
    }
    else if (groupBy === 'Action Item Planning Summary') {
      const planningSummary = determinePlanningSummary(actionItem)
      groupValue = [planningSummary];
    } else if (groupBy === 'createdOn' || groupBy.startsWith('createdOn') && groupBy.endsWith('_Day')) {
      groupValue = [getActionItemCreatedOnDate(actionItem)];
    }
    else if (groupBy.startsWith('createdOn') && groupBy.endsWith('_Year')) {
      groupValue = [getActionItemCreatedOnYear(actionItem)];
    }
    else if (groupBy.startsWith('createdOn') && groupBy.endsWith('_Quarter')) {
      groupValue = [getActionItemCreatedOnQuarter(actionItem)];
    }
    else if (groupBy.startsWith('createdOn') && groupBy.endsWith('_Month')) {
      groupValue = [getActionItemCreatedOnMonth(actionItem)];
    }
    else if (groupBy.startsWith('createdOn') && groupBy.endsWith('_Week')) {
      groupValue = [getActionItemCreatedOnWeek(actionItem)];
    }
    else if (groupBy === 'createdBy') {
      const createdByName =
        `${actionItem.createdBy?.firstName || ''} ${actionItem.createdBy?.lastName || ''}` || 'N/A';
      groupValue = [createdByName]
    } else if (groupBy === 'updatedOn' || groupBy.startsWith('updatedOn') && groupBy.endsWith('_Day')) {
      const updatedOnDate = getActionItemUpdatedOnDate(actionItem);
      groupValue = [updatedOnDate];
    }
    else if (groupBy.startsWith('updatedOn') && groupBy.endsWith('_Year')) {
      groupValue = [getActionItemUpdatedOnYear(actionItem)];
    }
    else if (groupBy.startsWith('updatedOn') && groupBy.endsWith('_Quarter')) {
      groupValue = [getActionItemUpdatedOnQuarter(actionItem)];
    }
    else if (groupBy.startsWith('updatedOn') && groupBy.endsWith('_Month')) {
      groupValue = [getActionItemUpdatedOnMonth(actionItem)];
    }
    else if (groupBy.startsWith('updatedOn') && groupBy.endsWith('_Week')) {
      groupValue = [getActionItemUpdatedOnWeek(actionItem)];
    }
    else if (groupBy === 'updatedBy') {
      const updatedEvent = actionItem.activity?.find((event) =>
        event.event?.includes(`Workstream action ${actionItem.actionItemNumber} is updated`)
      );
      const updatedUser = updatedEvent?.owner || '<not set>';
      groupValue = [`${updatedUser.firstName} ${updatedUser.lastName}`];
    }

    else {
      groupValue = [actionItem[groupBy]]; // Default case
    }

    groupValue.forEach(val => {
      if (!grouped[val]) {
        grouped[val] = [];
      }
      grouped[val].push(actionItem);
    });
  });
  return grouped;
};


export default groupWorkstreamActionsBy;